import request from '@/utils/request'

// 容积表列表
export function getTableListPage(params) {
  return request({
    url: '/capacity-table-basic-info/listPage',
    method: 'get',
    params
  })
}
// 添加容积表
export function addTable(params) {
  return request({
    url: '/capacity-table-basic-info/add',
    method: 'post',
    data: params
  })
}
// 编辑容积表
export function updateTable(params) {
  return request({
    url: '/capacity-table-basic-info/update',
    method: 'put',
    data: params
  })
}
// 提交容积表
export function submitTable(params) {
  return request({
    url: '/capacity-table-basic-info/submit',
    method: 'put',
    data: params
  })
}
// 撤回容积表
export function withdrawTable(params) {
  return request({
    url: '/capacity-table-basic-info/withdraw',
    method: 'put',
    data: params
  })
}
// 打回容积表
export function refutationTable(params) {
  return request({
    url: '/capacity-table-basic-info/refutation',
    method: 'post',
    data: params
  })
}
// 检验是否还有额度
export function checkTable(params) {
  return request({
    url: '/capacity-table-basic-info/check',
    method: 'get',
    params
  })
}
// 获取报警项列表
export function getAlarmListByLan(params) {
  return request({
    url: '/capacity-table-basic-info/getLanguage',
    method: 'get',
    params
  })
}
// 上传容积表
export function importCompany(params) {
  return request({
    url: '/capacity-table-basic-info/upload',
    method: 'post',
    data: params
  })
}
// 用户下载容积表
export function downloadBlank(params) {
  return request({
    url: '/capacity-table-basic-info/downLoad',
    method: 'get',
    params
  })
}
// 作废容积表
export function delBlank(params) {
  return request({
    url: '/capacity-table-basic-info/delete',
    method: 'post',
    data: params
  })
}
// 客户限额数量接口
export function getLimitInfo(params) {
  return request({
    url: '/capacity-table-limit/getLimitInfo',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js